import React from 'react'

// types
import { PassDetail } from '../../../../types/types'

// hooks
import useMessages from '../../../../hooks/useMessages'

// styles
import * as SC from './PassStatusBadgeStyles'

type PassStatusBadgeProps = {
	passState: PassDetail['state']
}

const PassStatusBadge = (props: PassStatusBadgeProps) => {
	const { passState } = props
	const { messages } = useMessages()

	const getBadgeLabel = () => {
		switch (passState) {
			case 'EXPIRED':
				return messages.Expired
			case 'USED':
				return messages.Used
			case 'CANCELLED':
				return messages.Cancelled
			case 'ACTIVE':
			default:
				return messages.Active
		}
	}

	return <SC.Badge $isActive={passState === 'ACTIVE'}>{getBadgeLabel()}</SC.Badge>
}

export default PassStatusBadge
